import { p as proxyCustomElement, H, h, d as Host } from './p-BJEvNVLM.js';

const cosmosIconCss = ":host{color:var(--cosmos-icon-color, inherit);display:inline-block;height:var(--cosmos-icon-size, 1em);vertical-align:-0.1551724138em;width:var(--cosmos-icon-size, 1em)}svg,::slotted(svg){display:block;height:100%;width:100%}";

const CosmosIconPersonFollow = /*@__PURE__*/ proxyCustomElement(class CosmosIconPersonFollow extends H {
    constructor() {
        super();
        this.__registerHost();
        this.__attachShadow();
    }
    getRole() {
        return this.ariaLabel ? 'img' : undefined;
    }
    getAriaHidden() {
        return this.ariaLabel ? false : 'true';
    }
    render() {
        return (h(Host, { key: '38732ce9151f74f69176d761bd1eb233349841fe', role: this.getRole(), "aria-hidden": this.getAriaHidden(), "aria-label": this.ariaLabel }, h("svg", { key: 'ab29cbcfc1c1dd6e921f56e3b4d12816588e9d40', width: "22", height: "22", viewBox: "0 0 22 22", fill: "none", xmlns: "http://www.w3.org/2000/svg", part: "base" }, h("path", { key: 'eb8c464a586019d703ceed8b2b17411bd54b9da3', "fill-rule": "evenodd", "clip-rule": "evenodd", d: "M4.36 9.7a3.69 3.69 0 0 0 3.736 3.472 3.69 3.69 0 0 0 3.738-3.47l.298-2.642a4.04 4.04 0 0 0-.876-3.275 4.09 4.09 0 0 0-3.16-1.338 4.1 4.1 0 0 0-3.16 1.335 4.03 4.03 0 0 0-.88 3.256zm1.732-4.913a2.6 2.6 0 0 1 2.003-.808 2.59 2.59 0 0 1 2.005.81c.467.584.654 1.343.513 2.077l-.301 2.665A2.218 2.218 0 0 1 5.88 9.53l-.304-2.685a2.54 2.54 0 0 1 .515-2.058m9.206 14.227a6.22 6.22 0 0 0-2.898-4.97.503.503 0 0 0-.717.104l-.318.354a.424.424 0 0 0 .102.72 5.05 5.05 0 0 1 2.1 2.77H2.721a5.1 5.1 0 0 1 2.1-2.77.425.425 0 0 0 .112-.72l-.317-.354a.503.503 0 0 0-.717-.104A6.22 6.22 0 0 0 1 19.014a.517.517 0 0 0 .512.541h13.273a.516.516 0 0 0 .512-.54M17.377 5.5a.54.54 0 0 0-.537.545v2.286h-2.303a.54.54 0 0 0-.537.546v.246c0 .311.25.545.537.545h2.303v2.286c0 .312.25.546.537.546h.247a.54.54 0 0 0 .536-.546V9.668h2.303A.54.54 0 0 0 21 9.123v-.246a.54.54 0 0 0-.537-.546H18.16V6.045a.54.54 0 0 0-.537-.545z", fill: "currentColor" }))));
    }
    static get style() { return cosmosIconCss; }
}, [1, "cosmos-icon-person-follow", {
        "ariaLabel": [513, "aria-label"]
    }]);
function defineCustomElement() {
    if (typeof customElements === "undefined") {
        return;
    }
    const components = ["cosmos-icon-person-follow"];
    components.forEach(tagName => { switch (tagName) {
        case "cosmos-icon-person-follow":
            if (!customElements.get(tagName)) {
                customElements.define(tagName, CosmosIconPersonFollow);
            }
            break;
    } });
}

export { CosmosIconPersonFollow as C, defineCustomElement as d };
